const chunkMapping = {
	"3": [
		1375
	],
	"38": [
		6565
	],
	"72": [
		7072
	],
	"166": [
		7573
	],
	"234": [
		947
	],
	"244": [
		681
	],
	"365": [
		4355
	],
	"421": [
		5735
	],
	"464": [
		3637
	],
	"529": [
		2843
	],
	"659": [
		865
	],
	"703": [
		8773
	],
	"741": [
		5895
	],
	"791": [
		6113
	],
	"891": [
		5457
	],
	"990": [
		2117
	],
	"993": [
		6045
	]
};
const idToExternalAndNameMapping = {
	"681": [
		"default",
		"./HeaderApp",
		2575
	],
	"865": [
		"default",
		"./EcommerceApp",
		9733
	],
	"947": [
		"default",
		"./AuthApp",
		745
	],
	"1375": [
		"default",
		"./BookingBuilderApp",
		657
	],
	"2117": [
		"default",
		"./EmailBuilderApp",
		8055
	],
	"2843": [
		"default",
		"./CustomerAuthenticationApp",
		217
	],
	"3637": [
		"default",
		"./DynamicFormsAdminApp",
		4365
	],
	"4355": [
		"default",
		"./DynamicFormsApp",
		6993
	],
	"5457": [
		"default",
		"./SidebarApp",
		433
	],
	"5735": [
		"default",
		"./ServicesApp",
		4369
	],
	"5895": [
		"default",
		"./WebsiteBuilderApp",
		6737
	],
	"6045": [
		"default",
		"./POSApp",
		9473
	],
	"6113": [
		"default",
		"./MarketingApp",
		525
	],
	"6565": [
		"default",
		"./OffersApp",
		5443
	],
	"7072": [
		"default",
		"./IdleSessionApp",
		6567
	],
	"7573": [
		"default",
		"./POSBackOfficeApp",
		3861
	],
	"8773": [
		"default",
		"./ProductManagementApp",
		1277
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}